import { AfterViewInit, Directive, ElementRef, OnInit } from '@angular/core';
import { HomepageAnalyticsService } from '@app/services/analytics/analytics.service';

@Directive({
  selector: '[appTrackSeen]'
})
export class TrackSeenDirective implements AfterViewInit {
  el: HTMLElement;
  inViewObserver: IntersectionObserver;

  constructor(
    private element: ElementRef,
    private homepageAnalyticsService: HomepageAnalyticsService
  ) {
    this.el = element.nativeElement;
  }

  ngAfterViewInit(): void {
    this.inViewObserver = new IntersectionObserver(this.intersectionCheck.bind(this));
    this.inViewObserver.observe(this.el);
  }

  intersectionCheck(entries) {
    if (entries[0].isIntersecting) {
      this.inViewObserver.unobserve(this.el);
      const attrLinkId = this.el.getAttribute('wdpr-analytics-track-seen');
      console.log('Check:', attrLinkId);
      if (attrLinkId) {
        try {
          const parsedLinkId = JSON.parse(attrLinkId);
          this.homepageAnalyticsService.trackElement(parsedLinkId.linkId);
        } catch (e) {
          console.error('TrackSeen - Error with linkId', e);
        }
      }
    }
  }

}
